document.addEventListener('DOMContentLoaded', function () {
  class SubscriptionWidget extends HTMLElement {
    constructor() {
      super();

      this.items = this.querySelectorAll('.subscription-widget--item-header > fieldset input');
      this.frequencies = this.querySelector('.product-form-frequencies select');
      this.onceOffSummary = this.querySelector('.once-off-summary');
      this.subscriptionSummary = this.querySelector('.subscription-summary');

      if (document.querySelector('.pdp-sticky-atc')) {
        this.subStatusContainer = document.querySelector('.pdp-sticky-atc--info-subscription-status');
      }

      if (this.items) {
        for (const item of this.items) {
          item.addEventListener('change', this.itemChangeHandler.bind(this));
        }
      }

      if (this.frequencies) {
        this.frequencies.addEventListener('change', this.frequencyChangeHandler.bind(this));
      }

      // ✅ Keep prices in sync with variant selection
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const data = event && event.data ? event.data : null;
        if (!data || !data.variant || !data.sectionId) return;

        // Only respond if this widget lives inside the section that fired the event
        if (!this.closest(`#shopify-section-${data.sectionId}`)) return;

        this.updatePricesFromVariant(data.variant);
      });
    }

    disconnectedCallback() {
      if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
    }

    formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.money_format || window.Shopify.money_format);
      }
      // fallback (should almost never be used)
      return `$${(cents / 100).toFixed(2)}`;
    }

    updatePricesFromVariant(variant) {
      if (!variant || typeof variant.price !== 'number') return;

      // One-time price (if present)
      const oneTimePriceEl = this.querySelector('.subscription-widget-price-regular');
      if (oneTimePriceEl) oneTimePriceEl.textContent = this.formatMoney(variant.price);

      // Subscription price(s): compute from each item's data-adjustment (%)
      const subItems = this.querySelectorAll('.subscription-widget--item-subscribe, .subscription-widget--item[data-issubscription="true"]');
      subItems.forEach((item) => {
        const adj = parseFloat(item.dataset.adjustment || '0'); // percent
        const discounted = Math.round(variant.price - (variant.price * (adj / 100)));
        const subPriceEl = item.querySelector('.subscription-widget-price');
        if (subPriceEl) subPriceEl.textContent = this.formatMoney(discounted);
      });

      // Update summary blocks if they exist (device bundle UI)
      const firstSubItem = this.querySelector('.subscription-widget--item-subscribe, .subscription-widget--item[data-issubscription="true"]');
      const firstAdj = firstSubItem ? parseFloat(firstSubItem.dataset.adjustment || '0') : 0;
      const discountedFirst = Math.round(variant.price - (variant.price * (firstAdj / 100)));

      const summarySubPriceEl = this.querySelector('.subscription-summary .subscription-price');
      if (summarySubPriceEl) summarySubPriceEl.textContent = this.formatMoney(discountedFirst);

      const bundleTotalEl = this.querySelector('.bundle-total');
      if (bundleTotalEl) {
        const deviceCents = parseInt(bundleTotalEl.dataset.devicePrice || '0', 10);
        bundleTotalEl.textContent = this.formatMoney(deviceCents + discountedFirst);
      }

      const onceOffTotalEl = this.querySelector('.once-off-total');
      if (onceOffTotalEl && bundleTotalEl) {
        const deviceCents = parseInt(bundleTotalEl.dataset.devicePrice || '0', 10);
        onceOffTotalEl.textContent = this.formatMoney(deviceCents + variant.price);
      }

      // Tooltip variant title (if present)
      this.querySelectorAll('.tooltiptext .variant_title').forEach((el) => {
        el.textContent = variant.title || '';
      });
    }

    itemChangeHandler(e) {
      for (const item of this.items) {
        item.checked = item == e.target;
        let itemParent = item.closest('.subscription-widget--item');

        if (itemParent) {
          let isSuscription = e.target.closest('.subscription-widget--item').dataset.issubscription == 'true';

          itemParent.classList.toggle('active', item == e.target);
          if (this.onceOffSummary) this.querySelector('.once-off-summary').classList.toggle('hidden', item != e.target);
          if (this.subscriptionSummary) this.querySelector('.subscription-summary').classList.toggle('hidden', item == e.target);

          if (isSuscription) {
            this.querySelector('[name="selling_plan"]:not([value=""])').checked = true;
          } else {
            if (this.onceOffSummary) this.querySelector('.once-off-summary').classList.toggle('hidden', item != e.target);
            if (this.subscriptionSummary) this.querySelector('.subscription-summary').classList.toggle('hidden', item == e.target);
          }

          if (this.subStatusContainer) {
            if (isSuscription) {
              this.subStatusContainer.innerHTML = `Every ${this.querySelector('[name="selling_plan"]:checked ~ span').innerHTML}`;
            } else {
              this.subStatusContainer.innerHTML = "{{- 'products.product.subscription.one_time_heading' | t -}}";
            }
          }
        }
      }
    }

    frequencyChangeHandler(e) {
      if (this.subStatusContainer) {
        this.subStatusContainer.innerHTML = `Every ${this.querySelector('[name="selling_plan"]:checked ~ span').innerHTML}`;
      }
    }
  }

  customElements.define('subscription-widget', SubscriptionWidget);
});
